import React from "react"
import imageMacBook from "images/macbook.png"
import imageIphone from "images/iphone.png"

const whatwedo = (props) => {
  return (
    <div ref={props.whatWeDoRef} className="secao-2" id="what-we-do">
      <img
        alt="macbook"
        className="macbook wow animated bounceInDown"
        src={imageMacBook}
      />
      <img
        alt="iphone"
        className="iphone wow animated bounceInUp"
        src={imageIphone}
      />
      <div className="wrap">
        <div className="w-50 left">
          <h3>What We Do</h3>
          <p>
            Lunch Team pairs up with your city's best health food restaurants to
            provide free lunch delivery, straight to your company's office.
            That's right, completely free with no minimum orders and no delivery
            fees. From individuals ordering a healthy salad, team leaders
            holding a brown bag meeting or office managers offering lunch to the
            company, our bespoke food solution fuels the performance of some of
            the worlds best companies.
          </p>
          <a onClick={props.HandleFindOutMore} className="bt get-more-info">Find out more</a>
        </div>
      </div>
    </div>
  )
}

export default whatwedo



// WEBPACK FOOTER //
// ./src/containers/Landing/WhatWeDo/index.js